import { Injectable } from '@angular/core';
import {
  GenerateDeviceActivationCodeResponseMessage,
  GenerateDeviceCodeResponseModel,
} from '../shared/services/evergent/signup/model/activation-code/device-activation-code.response.model';
import { LocalStorageService } from '../shared/services/storage/local-storage.service';
import { KEYS } from '../shared/utils/constants/storage.constants';
import { SignUpService } from '../shared/services/evergent/signup/signup.service';
import {
  isSuccessfulResponse,
  errorCode,
  getErrorMessage,
} from '../shared/utils/evergentUtils';
import { ContentEntitlementService } from '../shared/services/evergent/entitlement/content-entitlement.service';
import { NewrelicService } from '../analytics/newrelic/services/newrelic.service';
import { AppEventName } from '../analytics/newrelic/enums/EventName';

@Injectable()
export class LinkTvService {
  constructor(
    private readonly localStorage: LocalStorageService,
    private readonly signUpService: SignUpService,
    private readonly contentEntlmntService: ContentEntitlementService,
    private readonly newrelic: NewrelicService
  ) {}

  setTokens(data: GenerateDeviceCodeResponseModel) {
    this.localStorage.setItem(KEYS.EVERGENT_ACCESS_TOKEN, data.accessToken);
    this.localStorage.setItem(KEYS.REFRESH_TOKEN, data.refreshToken);
  }

  getActivationCode(
    result: (response?: GenerateDeviceActivationCodeResponseMessage) => void
  ): void {
    this.signUpService
      .generateDeviceActivationCode()
      .subscribe((response: GenerateDeviceActivationCodeResponseMessage) => {
        if (
          isSuccessfulResponse(
            response.GenerateDeviceActivationCodeResponseMessage
          )
        ) {
          result(response);
        } else {
          const errorBody =
            response?.GenerateDeviceActivationCodeResponseMessage;
          this.newrelic.store.clearCustomAttributes();
          this.newrelic.sendErrorEvent({
            error: {
              errorCode: errorCode(errorBody),
              errorMessage: getErrorMessage(errorBody),
              errorDescription: `Device activation code generation failed: ${getErrorMessage(errorBody)}`,
            },
          });
          result();
        }
      });
  }

  async fetchTvodPurchasedList() {
    return await this.contentEntlmntService.fetchVodEntitlements();
  }
}
